
<div
  v-if="isPromoVisible"
  :id="content.idHTML"
  class="d-flex flex-column align-items-center"
  :class="jel_getClassObject(content)"
>
  <b-link
    :class="[content.variantBoutonCodePromo ? content.variantBoutonCodePromo : 'hyperlienModal']"
    @click="$bvModal.show(modaleUUID)"
    >{{ content.libBoutonCodePromo }}</b-link
  >
  <b-modal
    :id="modaleUUID"
    hide-footer
    centered
    align-h="center"
    content-class="compteClair"
    body-class="mx-2 mx-md-4 pt-0 mb-3"
    header-class="justify-content-end"
    @hidden="onClose()"
  >
    <template #modal-header="{ close }">
      <div class="d-flex">
        <div class="col-11"></div>
        <div v-if="content.titreFenetreModale" class="posBtnClose">
          <button class="compteClair btnClose" @click="close()">
            <svg-icon
              icon-name="icone-fermer-mince"
              color="$couleur-primaire"
              className="iconeFermer"
            ></svg-icon>
          </button>
        </div>
      </div>
      <div class="d-flex mt-4">
        <div v-if="content.titreFenetreModale" class="col-12 px-0">
          <h2
            class="compteClair grandTitre ml-3 ml-md-5 mr-1"
            v-html="jel_replaceTokens(content.titreFenetreModale)"
          ></h2>
        </div>
      </div>
    </template>

    <div>
      <div class="texte text-left graphik_regular mx-1 pb-0 mb-3 mb-md-3" v-html="textePromo" />
      <MessageMel
        v-show="message"
        :content="messageErreur"
        class="mx-n1 mx-md-1 pt-0 mb-1 mb-md-2"
      ></MessageMel>

      <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }" tag="div" class="mx-n1">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
          <ValidationProvider
            v-slot="{ errors }"
            :name="content.libCodePromo"
            :rules="`required|is_code_promo_valid`"
            tag="div"
          >
            <div class="col-12 col-lg-11 col-md-11 col-xl-9">
              <b-form-group :label="content.libCodePromo" label-for="champCodePromo">
                <b-form-input
                  id="champCodePromo"
                  v-model="codePromo"
                  class="text-uppercase pr-1"
                  autocomplete="off"
                  maxlength="16"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @blur.native="forceValidate()"
                />
              </b-form-group>
              <ErreurValidation
                v-if="errors[0] !== 'MSG00-04'"
                id="promo-invalid-feedback"
                class="mt-n2 pb-0"
                :message="errors[0]"
              ></ErreurValidation>
            </div>
            <div class="col-1"></div>
            <div
              class="d-flex flex-column"
              :class="[
                content.classeBoutonContinuer
                  ? content.classeBoutonContinuer
                  : 'align-items-center mt-2 mb-2',
              ]"
            >
              <b-button
                type="submit"
                variant="primaire"
                class="btn w-auto hauteur px-4"
                :disabled="errors.length > 0 || codePromo.length === 0"
                :class="{ valid: errors.length == 0 }"
              >
                <div v-if="isSubmitted" class="mr-1">
                  <b-spinner small :label="$t('chargement')"></b-spinner>
                </div>
                {{ content.libBoutonContinuer }}</b-button
              >
              <b-link class="lienSecondaire pb-0" @click="$bvModal.hide(modaleUUID)">
                {{ content.libBoutonAnnuler }}
              </b-link>
            </div>
          </ValidationProvider>
        </b-form>
      </ValidationObserver>
    </div>
  </b-modal>
</div>
